import {  Stack, Typography } from '@mui/material';
import { FC } from 'react';
import PhoneInput from 'react-phone-input-2';
import { EventNames } from '../../constants/constants';
import { Modal } from '../Modal/Modal';
import {
  Container,
  Title,
  Subtitle,
  PhoneWrapper,
  PhoneNumber,
  BtnVerify,
  OutlinedBtnVerify,
  ButtonBack,
} from './ExistingUserModal.helper';
import { useTrackEvent } from '../../hooks/useTrackEvent';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  phoneNumber: string;
  goToSignup: () => void;
  trackProperties?: {
    accountId: string;
    phoneNumber?: string;
    name?: string;
    email?: string;
  };
}

export const ExistingUserModal: FC<Props> = ({ phoneNumber, isOpen, onClose, goToSignup, trackProperties }) => {
  const { trackEvent } = useTrackEvent();
  
  const trackClick = (action: string) => {
    trackEvent({
      action,
      location: window.location.href,
      accountId: trackProperties?.accountId || '',
      phoneNumber: phoneNumber,
      name: trackProperties?.name,
      email: trackProperties?.email,
    });
  };

  const onLoginWithThisNumber = () => {
    trackClick(EventNames.Existing_User_Modal_Proceed);
    onClose();
  };

  const onUseDifferentNumber = () => {
    trackClick(EventNames.Existing_User_Modal_Return_To_Signup);
    goToSignup();
    onClose();
  };

  const onOutsideClick = () => {
    trackClick(EventNames.Existing_User_Modal_Click_Outside);
    onClose();
  };

  return (
    <Stack>
      {isOpen && (
        <Modal onClose={onOutsideClick} isCloseButton={false} semiTransparentBgr>
          <Container>
            <Stack component={Container}>
              <Title>{'Existing User'}</Title>
              <PhoneWrapper style={{ flexDirection: 'column' }}>
                <PhoneNumber component={Typography}>
                  <PhoneInput value={phoneNumber} disabled />
                </PhoneNumber>
                <Subtitle>
                  {'The number you provided is connected with an existing account.'}
                </Subtitle>
              </PhoneWrapper>

              <BtnVerify size="small" variant="contained" onClick={onLoginWithThisNumber}>
                {'Login With This Number'}
              </BtnVerify>
              <OutlinedBtnVerify
                size="small"
                variant="outlined"
                onClick={() => {
                  onUseDifferentNumber();
                }}
              >
                {'Use A Different Number'}
              </OutlinedBtnVerify>
              <ButtonBack size="small" onClick={onClose}>
                {'Back'}
              </ButtonBack>
            </Stack>
          </Container>
        </Modal>
      )}
    </Stack>
  );
};
